import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { HelpersService } from 'src/app/helpers.service'

@Injectable({
  providedIn: 'root'
})
export class SearchProjectsService {
  private builderUrl = ''

  projects = {}
  selectedProject = 0
  headerBtn = ''
  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  token: any
  constructor(
    private http: HttpClient,
    private helper: HelpersService,
    private builderService: BuilderService
  ) {
    this.builderUrl = this.helper.getBuilderUrl()
  }

  /**
   * Get all templates from Backend
   */
  searchProjects = (domain: string): Observable<any> => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('domain', domain)
    postData.set('token', this.token)
    return this.http.post(this.builderUrl + 'searchProjects', postData.toString(), this.options)
  }
}
